import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@olxbr/design-system'

const MailIcon = props => (
  <View>
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M48.1149 87.3109C69.762 87.3109 87.3104 69.7625 87.3104 48.1154C87.3104 26.4683 69.762 8.91992 48.1149 8.91992C26.4679 8.91992 8.91943 26.4683 8.91943 48.1154C8.91943 69.7625 26.4679 87.3109 48.1149 87.3109Z"
        fill="#6E0AD6"
      />
      <path
        d="M12.0589 24.6551L64.6551 17.2632C68.2711 16.755 71.6454 19.2977 72.1536 22.9137L77.6976 62.3609C78.2058 65.9769 75.663 69.3512 72.047 69.8594L19.4508 77.2513C15.8348 77.7595 12.4605 75.2168 11.9523 71.6008L6.40836 32.1536C5.90017 28.5376 8.44291 25.1633 12.0589 24.6551Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1656 25.667C9.08684 26.0997 6.88319 28.8793 7.11251 31.9385L42.3902 49.9072L71.348 22.9112C70.7253 19.9071 67.8408 17.8424 64.7619 18.2751L12.1656 25.667ZM12.6974 71.7656L7.35389 33.7449L42.1772 51.4821C42.4581 51.6252 42.7985 51.5774 43.029 51.3624L71.6254 24.7033L74.8224 46.0463C74.8838 46.4559 75.2656 46.7382 75.6753 46.6769C76.0849 46.6155 76.3672 46.2337 76.3059 45.824L72.9011 23.0948C72.8995 23.0813 72.8976 23.0678 72.8953 23.0544C72.3179 19.0411 68.5712 16.225 64.5531 16.7897L11.9569 24.1816C7.9307 24.7474 5.10218 28.501 5.66802 32.5272L11.212 71.9744C11.7778 76.0005 15.5314 78.8291 19.5576 78.2632L19.5576 78.2633L19.5675 78.2618L43.3526 74.5941C43.762 74.531 44.0427 74.148 43.9796 73.7386C43.9164 73.3292 43.5334 73.0485 43.124 73.1117L19.3441 76.7785C16.1401 77.2262 13.1477 74.9698 12.6974 71.7656ZM16.947 71.7638C16.709 72.1028 16.7909 72.5705 17.1299 72.8085C17.4689 73.0465 17.9367 72.9647 18.1747 72.6257L21.1437 68.3968C21.3817 68.0578 21.2999 67.59 20.9609 67.352C20.6219 67.114 20.1541 67.1959 19.9161 67.5349L16.947 71.7638ZM21.969 64.6109C21.731 64.9499 21.8128 65.4177 22.1519 65.6557C22.4909 65.8937 22.9586 65.8119 23.1966 65.4728L32.5279 52.1822C32.7659 51.8432 32.6841 51.3754 32.3451 51.1374C32.0061 50.8994 31.5383 50.9813 31.3003 51.3203L21.969 64.6109Z"
        fill="#4A4A4A"
      />
      <path
        d="M79.5706 81.3576C87.0918 74.9637 88.0057 63.6833 81.6117 56.1621C75.2178 48.6409 63.9374 47.7271 56.4162 54.121C48.895 60.5149 47.9812 71.7954 54.3751 79.3166C60.769 86.8378 72.0495 87.7516 79.5706 81.3576Z"
        fill="#6E0AD6"
        stroke="#4A4A4A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.1611 65.5161L74.0574 64.6198C74.9882 63.689 74.9882 62.1741 74.0574 61.2429C73.6066 60.7925 73.0075 60.5449 72.3687 60.5449C71.7299 60.5449 71.1304 60.7929 70.6801 61.2432L69.7841 62.1392L73.1611 65.5161ZM69.005 62.9183L62.3675 69.5557C62.2261 69.6972 62.1185 69.8717 62.056 70.0608L60.8255 73.7787C60.7597 73.9763 60.8115 74.1941 60.9588 74.3414C61.0642 74.4465 61.2045 74.5027 61.3485 74.5027C61.4066 74.5027 61.465 74.4935 61.5219 74.4748L65.2387 73.2438C65.4286 73.1814 65.6034 73.0737 65.7449 72.932L72.3819 66.2949L69.005 62.9183Z"
        fill="white"
      />
    </svg>
  </View>
)

MailIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

MailIcon.defaultProps = {
  width: 96,
  height: 96,
}

export default MailIcon
